import React from "react";
import { delay, motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import {
  containerVariants,
  itemVariants,
  photoVariants,
} from "../../variants/variants";

const Section2 = () => {
  const { t } = useTranslation();
  const strategies = t("rnd.strategies", { returnObjects: true });

  return (
    <motion.div
      initial="hidden"
      whileInView="visible"
      exit="exit"
      variants={containerVariants}
      className="my-14  ">
      <div className="grid grid-cols-10">
        <div className="space-y-3 col-span-8  md:col-span-4">
          <motion.h1 variants={itemVariants} className=" text-65  text-customBlack  leading-none">
            {t("rnd.strategiesTitle")}
          </motion.h1>
          {strategies.map((item, index) => (
            <motion.div key={index} variants={itemVariants} className="flex items-center space-x-2">
              <div className="h-2 w-2 bg-[#E1CD71] rounded-full"></div>
              <h6 className="text-18 font-medium  text-customGray5">
                {item}
              </h6>
            </motion.div>
          ))}
        </div>

        <div className="col-span-8 md:col-span-6  overflow-hidden">
          <motion.img
                  initial="initial"
                  whileInView="whileInView"
                  exit="exit"
                  variants={photoVariants}
            src="/images/rand/1.png"
            className="h-full w-full   object-cover"
          />
        </div>
      </div>
    </motion.div>
  );
};

export default Section2;
